module.exports = __webpack_public_path__ + "static/media/ic-bank-black.197a4acb.svg";